// extracted by mini-css-extract-plugin
export default {"gradientBg":"style_gradientBg__OSAoc","iconLike":"style_iconLike__r5JEP","iconLikeSmall":"style_iconLikeSmall__C-mSK"};